import { useEffect, useState } from 'react'
import leftArrow from '../../assets/icons/LeftArrow.svg'
import rightArrow from '../../assets/icons/RightArrow.svg'
import DeleteIcon from '../../assets/icons/DeleteIcon.svg'

const ImageCarousel = ({
  imageUrls,
  handleDelete,
}: {
  imageUrls: string[]
  handleDelete: (index: number) => void
}) => {
  const [startIndex, setStartIndex] = useState(0)
  const [imagesPerView, setImagesPerView] = useState(3)

  useEffect(() => {
    const updateImagesPerView = () => {
      const width = window.innerWidth
      if (width < 768) setImagesPerView(2)
      else setImagesPerView(3)
    }

    updateImagesPerView()
    window.addEventListener('resize', updateImagesPerView)

    return () => window.removeEventListener('resize', updateImagesPerView)
  }, [])

  const handleNext = () => {
    setStartIndex((prevIndex) => prevIndex + imagesPerView)
  }

  const handlePrev = () => {
    setStartIndex((prevIndex) => prevIndex - imagesPerView)
  }

  const visibleImages = imageUrls.slice(startIndex, startIndex + imagesPerView)

  const isNextDisabled = startIndex + imagesPerView >= imageUrls.length
  const isPrevDisabled = startIndex <= 0

  return (
    <div className="flex items-center gap-4 w-full">
      {imageUrls.length > 0 && (
        <button
          onClick={handlePrev}
          disabled={isPrevDisabled}
          className={isPrevDisabled ? 'cursor-not-allowed opacity-50' : ''}
        >
          <img src={leftArrow} alt="Previous" />
        </button>
      )}

      <div className="flex gap-4 md:gap-8">
        {imageUrls.length > 0 ? (
          visibleImages.map((url, index) => {
            const actualIndex = (startIndex + index) % imageUrls.length
            return (
              <div key={actualIndex} className="relative">
                <img
                  src={url}
                  alt={ `${actualIndex}`}
                  className="w-[150px] h-[85px] md:w-[300px] md:h-[199px] object-cover rounded-lg"
                />
                <img
                  src={DeleteIcon}
                  alt="Delete"
                  className="absolute top-3 right-2 cursor-pointer"
                  onClick={() => handleDelete(actualIndex)}
                />
              </div>
            )
          })
        ) : (
          <p className="text-center w-full">No images to display.</p>
        )}
      </div>

      {imageUrls.length > 0 && (
        <button
          onClick={handleNext}
          disabled={isNextDisabled}
          className={isNextDisabled ? 'cursor-not-allowed opacity-50' : ''}
        >
          <img src={rightArrow} alt="Next" />
        </button>
      )}
    </div>
  )
}

export default ImageCarousel
